const {Cookies} = window;

const Tracker = function (_trackerUrl, {
  title,
  section,
  contentType,
  origin,
  clickType,
  url,
  id,
  edition,
  tags,
  site
}) {

  /**
   * Versión dej js
   */
  var version = '1.0';

  /**
   * Log
   */
//  var log = console.log;

  /**
   * URL del servicio de tracking
   */
  var trackerUrl = null;

  /**
   * Establecer las variables desde la configuración
   */
  function setVarsFromConfig() {
    trackerUrl = _trackerUrl;
//    log('Tracker::setVarsFromConfig => trackerUrl: ' + trackerUrl);

    return this;
  }

  /**
   * Establece valor de trackerUrl según el valor pasado como parametro
   * @param (string) url
   */
  function setTrackerUrl(url) {
    trackerUrl = url;

    return this;
  }

  /**
   * Devuelve trackerUrl del medio
   */
  function getTrackerUrl() {
    return trackerUrl;
  }

  /**
   * Enviar visita a plataforma de estadística
   * @param (string) title
   * @param (string) section
   * @param (string) contentType
   * @param (string) origin
   * @param (string) clickType
   * @param (string) url
   * @param (string) id
   * @param (string) edition (no requerido)
   * @param (string) tags (no requerido)
   */
  function sendViewStats(title, section, contentType, origin, clickType, url, id, edition, tags, evo_sid, site) {
    if (typeof title !== 'undefined' && title !== null &&
      typeof section !== 'undefined' && section !== null &&
      typeof contentType !== 'undefined' && contentType !== null &&
      typeof origin !== 'undefined' && origin !== null &&
      typeof clickType !== 'undefined' && clickType !== null &&
      typeof url !== 'undefined' && url !== null &&
      typeof id !== 'undefined' && id !== null &&
      typeof evo_sid !== 'undefined' && evo_sid !== null) {
      var voc_adb = 0;
      var voc_cookies = 0;
      if (vocAdblock) {voc_adb = 1;}
      if (cookiesEnabled) {voc_cookies = 1;}
      var urlTracking = trackerUrl + '/stats/v2/visit?title=' + window.escape(title) + '&section=' + section + '&content_type=' + contentType + '&origin=' + origin + '&click_type=' + clickType + '&url=' + window.escape(url) + '&id=' + id + '&edition=' + edition + '&tags=' + window.escape(tags);
      urlTracking += '&id_user=' + evo_sid + '&adb_enabled=' + voc_adb + '&cookies_enabled=' + voc_cookies;
//      log('Tracker::sendViewStats => ' + urlTracking);

      if (site) {urlTracking += '&site=' + site;}

      window.$.ajax({
        url: urlTracking,
        dataType: 'jsonp',
        async: true
      });
    } else {
      throw Error('[TagManager] tracker config');
    }
  }

  /**
   * Nos dice si las cookies estan habilitadas
   */
  function areCookiesEnabled() {
    var cookieEnabled = (window.navigator.cookieEnabled) ? true : false;
    if (typeof window.navigator.cookieEnabled == "undefined" && !cookieEnabled) {
      document.cookie = "testcookie";
      cookieEnabled = (document.cookie.indexOf("testcookie") != -1) ? true : false;
    }
    return (cookieEnabled);
  }

  /**
   * Crea una cadena aleatoria que sirve como id de usuario en caso de no existir uno.
   */
  function makeid() {
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (var i = 0; i < 25; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  }

  /**
   * Obtiene el identificador de usuario.
   * Si existe cookie ev_sid coge ese, sino busca si existe voc_uid (solo usuarios registrados).
   * Si el usuario es registrado mete el uid en stats_uid para saber cuando no esta registrado que usuario es.
   * Si no esta con sesión iniciada y no existe ev_sid se genera una cadena aleatoria que se guarda en la cookie stats_uid.
   */
  function getUserId() {
    var user_id = Cookies.get("ev_sid");
    if (user_id === undefined) {
      var uid_obj = Cookies.get("voc_uid");
      if (uid_obj) {
        user_id = uid_obj.uid;
        Cookies.set('stats_uid', user_id, {
          path: '/'
        });
      }
    }
    if (user_id === undefined) {
      user_id = Cookies.get('stats_uid');
      if (user_id === undefined) {
        user_id = makeid();
        Cookies.set('stats_uid', user_id, {
          path: '/'
        });
      }
    }
    return user_id;
  }

  /**
   * Ejecutable al instanciar el objeto
   */
  setVarsFromConfig();

  /**
   * Recogemos los parámetros (de la variable global _voctrack)
   */
  // var params = Array();
  // for(var cont = 0; cont < parent._voctrack.length; cont++) {
  //     params[parent._voctrack[cont][0]] = parent._voctrack[cont][1];
  // }

  /**
   * Recogemos si el adblock esta activado o no
   */
  var vocAdblock = false;
  if (window.voc_adb) {
    vocAdblock = true;
  }

  /**
   * Recogemos si las cookies estan activadas o no
   */
  var cookiesEnabled = false;
  cookiesEnabled = areCookiesEnabled();

  /**
   * Recogemos el user_id actual
   */
  var user_id = getUserId();

  /**
   * Tracking de la visita
   */
  sendViewStats(title, section, contentType, origin, clickType, url, id, edition, tags, user_id, site);

  /**
   * Métodos públicos
   */
  return {
    version: function () {
      return version;
    },
    setTrackerUrl: setTrackerUrl,
    getTrackerUrl: getTrackerUrl,
    sendViewStats: sendViewStats
  };
};

export default Tracker;



// WEBPACK FOOTER //
// ./src/legacy/tracker.js